import { gsap } from "../gsap/all.js";
import { ScrollTrigger } from "../gsap/ScrollTrigger.js";
import A11yDialog from "a11y-dialog";
gsap.registerPlugin(ScrollTrigger);
// gsap.config({nullTargetWarn:false});
import counterUp from 'counterup2'
export default {

	init() {

		var $nav = $('.main_header .inner.sticky');
		var scrollTriggerHeight = 150;
		var lastScrollTop = 0;

		$(window).scroll(function() {
			var scrollTop = $(this).scrollTop();
			var isScrollingUp = scrollTop < lastScrollTop;

			if (scrollTop > scrollTriggerHeight) {
				$nav.addClass('sticky-hidden');
			} else {
				$nav.removeClass('sticky-hidden');
			}

			if (isScrollingUp) {
				$nav.addClass('scrollingUp').removeClass('sticky-hidden');
				$('.contact-box').addClass('sup');
			} else {
				$nav.removeClass('scrollingUp');
			}

			lastScrollTop = scrollTop;

			if (scrollTop === 0) {
				$('.contact-box').removeClass('sup');
			}
		});

		function scrollDirection(last, delta, st, scroll) {
			if (Math.abs(last - st) <= delta) {
				return;
			}

			if (st > lastScrollTop) {
				scroll = 'down';
			} else {
				scroll = 'up';
			}

			lastScrollTop = st;
			return scroll;
		}

		if ($('body').hasClass('contact')) {
			let pstl = gsap.timeline({
				scrollTrigger: {
					trigger: '.marquee-section',
					scrub: true,
					start:"bottom 120px",
				},
			});
			pstl.to('.tel', { color: '#222', duration: 0.5 })
		}

		if ($('body').hasClass('home')) {
			let pstl = gsap.timeline({
				scrollTrigger: {
					trigger: '.hero_section',
					scrub: true,
					start:"bottom 120px",
				},
			});
			pstl.to('.tel', { color: '#222', duration: 0.5 })
		}


// Step 1: Get ALL elements on the page
let allElements = document.querySelectorAll("*");

// Step 2: Find elements with position:sticky
let stickyElements = [];
for (let i = 0; i < allElements.length; i++) {
	let element = allElements[i];
	let computedStyle = getComputedStyle(element);
	if (computedStyle.position === "sticky") {
		stickyElements.push(element);
	}
}

// Step 3: Check parent elements for overflow styles
for (let i = 0; i < stickyElements.length; i++) {
	let stickyElement = stickyElements[i];
	let parent = stickyElement.parentElement;
	while (parent) {
		let parentComputedStyle = getComputedStyle(parent);
		if (parentComputedStyle.overflow !== "visible") {
			console.log(
				"This ancestor of a position:sticky element has overflow set to something other than visible, so it might cause problems."
				);
			console.log(parent);
		}
		parent = parent.parentElement;
	}
}


$('#mobileMenuNav').append($('#desktop-nav').html());
$('#mobile-bottom-container').append($('#contact-box').html());


$("#menu_activator").on("click", function(){
	$(this).toggleClass("active");
	$(this).closest(".main_header").toggleClass("mobile_menu_active");
	$("#mobile-menu-wrapper").slideToggle().toggleClass("active");
	$('html,body').animate({scrollTop: 0}, 500);
		  // $('body').toggleClass('overflow');
		})
$('#mobileMenuNav .sub-menu').hide();
$('#mobileMenuNav li.menu-item-has-children').each(function() {

	var $toggleArea = $('<span class="submenu-toggle"></span>');
	$(this).append($toggleArea);

	$toggleArea.on('click', function(event) {
		event.stopPropagation();
		$(this).siblings('.sub-menu').slideToggle(200);
		$(this).toggleClass('is-active');
	});
});

$('#mobileMenuNav li.menu-item-has-children > a').on('click', function(event) {
	event.stopPropagation();
});
var windowPosition;
var lastScrollTop = 0;
var navHeight = $(".main_header").outerHeight();
function headerScroll() {
	windowPosition = window.scrollY > 50;
	var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	var mainHeader = $(".main_header")
	mainHeader.toggleClass("scrolling-active", windowPosition);

	if ($(window).width() < 768 && !mainHeader.hasClass("mobile_menu_active")) {
		if (scrollTop > lastScrollTop && lastScrollTop >= 0) {
			mainHeader.css("top", -(navHeight + 200));
		} else {
			mainHeader.css("top", "0");
		}
	}
	lastScrollTop = scrollTop;
}
function viewportHeightFix() {

	var vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${vh}px`);

}
try {
	setTimeout(viewportHeightFix, 100);
	headerScroll()
	$(window).scroll(headerScroll);
	$(window).resize(viewportHeightFix);
	$(window).resize( headerScroll);

} catch (e) {
	console.log(e)
}



$('#desktop-nav li.menu-item-has-children').hover(
	function() {
			  // Slide down the sub-menu when the mouse hovers over the li element
			  $(this).children('ul.sub-menu').stop(true, true).slideDown();
			},
			function() {
			  // Slide up the sub-menu when the mouse leaves the li element
			  $(this).children('ul.sub-menu').stop(true, true).slideUp();
			}
			);

try{

	const callback = entries => {
		entries.forEach(entry => {
			const el = entry.target;
			if (entry.isIntersecting) {
				if (!el.classList.contains('is-visible')) {
					counterUp(el, {
						duration: 2000,
						delay: 16,
					});
					el.classList.add('is-visible');
				}
			} else {

				if (el.classList.contains('is-visible')) {
					el.classList.remove('is-visible');

				}
			}
		});
	};

	const IO = new IntersectionObserver( callback, { threshold: 1 } )

	const els = document.querySelectorAll('.counter');

	els.forEach(el => {
		IO.observe(el);
	});

} catch (e) {
	console.error("Error initializing counters:", e);
}
$("input, textarea").each(function(e){
	$(this).val().length != 0 ? $(this).closest(".gfield").find("label").addClass("active") : '';
});
$("input, textarea").on("focus", function(e){
	$(this).closest(".gfield").find("label").addClass("active");
}).on("blur change", function(){
	$(this).val().length == 0 ? $(this).closest(".gfield").find("label").removeClass("active") : '';
});

$('.testimonials-slider').slick({
	dots: false,
	infinite: true,
	slidesToShow: 1,
	slidesToScroll: 1,
	speed: 500,
	cssEase: 'linear',
	autoplay:false,
	autoplaySpeed: 10000,
	arrows: true,
	prevArrow: $('#testimonials-prev'),
	nextArrow: $('#testimonials-next'),
});



},
finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js